import { ExternalLink, GitMerge } from "lucide-react";
import { CATEGORY_LABELS } from "../lib/constants";
import { memo } from "react";

function timeAgo(dateStr, now) {
  const diffMs = now - new Date(dateStr);
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 1) return "Lige nu";
  if (diffMins < 60) return `${diffMins} min siden`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours} t siden`;
  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays} d siden`;
}

export const FeedItem = memo(function FeedItem({ article, isActive, isNew, onClick, now }) {
  const sourceName = article.source_count > 1
    ? `${article.source} +${article.source_count - 1}`
    : article.source;
  const isGrouped = article.source_count > 1;

  return (
    <button
      onClick={() => onClick(article)}
      className={`w-full text-left px-5 py-4 border-b border-[#E5E5E5] dark:border-zinc-800 transition-all duration-150 cursor-pointer group focus:outline-none ${
        isActive
          ? "bg-[#F2F2F2] dark:bg-zinc-900"
          : "bg-white dark:bg-zinc-950 hover:bg-[#FAFAFA] dark:hover:bg-zinc-900"
      } ${isNew ? "flash-new feed-item-enter" : ""}`}
      data-testid="news-feed-item"
      aria-label={`${article.neutral_title} - ${sourceName}`}
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="text-[10px] tracking-[0.2em] uppercase font-mono text-gray-400">
          {timeAgo(article.published_at, now)}
        </span>
        <span className="text-gray-300 dark:text-zinc-700">|</span>
        <span className="text-[10px] tracking-[0.2em] uppercase font-mono text-gray-500 dark:text-gray-400 font-semibold">
          {sourceName}
        </span>
        <span className="text-gray-300 dark:text-zinc-700">|</span>
        <span className="text-[10px] tracking-[0.2em] uppercase font-mono text-gray-500 dark:text-gray-400">
          {CATEGORY_LABELS[article.category] || article.category}
        </span>
      </div>

      <h3 className="text-sm font-semibold leading-snug text-[#0A0A0A] dark:text-zinc-100 group-hover:underline underline-offset-2 mb-2 font-['Archivo']">
        {article.neutral_title}
      </h3>

      <div className="flex items-center justify-between">
        <span />
        <div className="flex items-center gap-2">
          {isGrouped && (
            <span
              className="inline-flex items-center text-gray-400"
              title={`Samlet fra ${article.source_count} kilder`}
              data-testid="grouped-story-icon"
              aria-label={`Samlet fra ${article.source_count} kilder`}
            >
              <GitMerge className="w-3 h-3" strokeWidth={1.5} />
            </span>
          )}
          <a
            href={article.original_url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="text-gray-400 hover:text-[#0A0A0A] dark:hover:text-zinc-50 transition-colors rounded-sm focus:outline-none"
            data-testid="source-link"
            aria-label={`Læs original artikel hos ${article.source}`}
          >
            <ExternalLink className="w-3 h-3" strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </button>
  );
});
